var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 100.8,
    height: 75.6,
    viewBox: "0 0 100.8 75.6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M84 4.2H23.1C19.6206 4.2 16.8 7.02061 16.8 10.5V48.3C16.8 51.7794 19.6206 54.6 23.1 54.6H84C87.4794 54.6 90.3 51.7794 90.3 48.3V10.5C90.3 7.02061 87.4794 4.2 84 4.2Z",
    fill: "#5B21B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M82.95 8.4H24.15C22.4103 8.4 21 9.8103 21 11.55V47.25C21 48.9897 22.4103 50.4 24.15 50.4H82.95C84.6897 50.4 86.1 48.9897 86.1 47.25V11.55C86.1 9.8103 84.6897 8.4 82.95 8.4Z",
    fill: "url(#paint0_linear_0_94)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.25,
    d: "M43.05 13.65H28.35C27.1902 13.65 26.25 14.5902 26.25 15.75V43.05C26.25 44.2098 27.1902 45.15 28.35 45.15H43.05C44.2098 45.15 45.15 44.2098 45.15 43.05V15.75C45.15 14.5902 44.2098 13.65 43.05 13.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.6,
    d: "M78.75 13.65H51.45C50.2902 13.65 49.35 14.5902 49.35 15.75V16.8C49.35 17.9598 50.2902 18.9 51.45 18.9H78.75C79.9098 18.9 80.85 17.9598 80.85 16.8V15.75C80.85 14.5902 79.9098 13.65 78.75 13.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.4,
    d: "M70.35 23.1H51.45C50.2902 23.1 49.35 24.0402 49.35 25.2C49.35 26.3598 50.2902 27.3 51.45 27.3H70.35C71.5098 27.3 72.45 26.3598 72.45 25.2C72.45 24.0402 71.5098 23.1 70.35 23.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.3,
    d: "M78.75 31.5H51.45C50.2902 31.5 49.35 32.4402 49.35 33.6V43.05C49.35 44.2098 50.2902 45.15 51.45 45.15H78.75C79.9098 45.15 80.85 44.2098 80.85 43.05V33.6C80.85 32.4402 79.9098 31.5 78.75 31.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M47.25 54.6H59.85L64.05 66.15H43.05L47.25 54.6Z",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M68.775 65.1H38.325C36.8753 65.1 35.7 66.2753 35.7 67.725C35.7 69.1747 36.8753 70.35 38.325 70.35H68.775C70.2248 70.35 71.4 69.1747 71.4 67.725C71.4 66.2753 70.2248 65.1 68.775 65.1Z",
    fill: "#4C1D95"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_94",
    x1: 21,
    y1: 8.4,
    x2: 59.266,
    y2: 67.7123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllDesktop);
export default __webpack_public_path__ + "static/media/ill-desktop.3af829c5c3bce613d612b316b5d9cdbf.svg";
export { ForwardRef as ReactComponent };